<template>
	<div class="table-area">
		<div v-show="tableLoading" class="loading-area">
			<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
		</div>

		<div v-show="!tableLoading" class="tag-table scroll-color">
			<ui-table v-show="!tableLoading"
				:columns="tableColumns"
				:data="tableData"
				:name="name"
				:loading="tableLoading"
				:last-col-fixed="false"
				:select-column-menu="false"
				design="small"
				tr-component="tags/tag-manager/configuration/components/tag-manager-table-line"
				not-found-text="Não foi possível encontrar nenhuma Tag"
				not-found-icon="fa fa-file-contract"
				table-options
				disable-ref
				@select-all="selectAllAction"
				@scroll="scrollHandler">
				<template #options>
					<div class="button-delete-tags" v-show="hasSelectItens" :class="tagTableClass">
						<ui-button design="danger sm" @click="deleteAllSelectedAction">
							Excluir selecionados
						</ui-button>
					</div>
				</template>
			</ui-table>

			<div v-if="paginateLoader" class="request-load">
				<ui-load-indicator :h="50" :stroke="8" bgColor="#DFE5EC" color="#69D296" />
			</div>
		</div>
	</div>
</template>

<script>
	import { uiTable, uiLoadIndicator } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'

	import { scrollPaginate } from '@/directives'

	export default {
		name: 'tag-manager-table',

		components: {
			uiLoadIndicator,
			uiTable,
			uiButton
		},

		directives: {
			scrollPaginate
		},

		props: {
			name: {
				type: String,
				required: true
			},
			tableLoading: {
				type: Boolean,
				default: false
			},
			hasSelectItens: {
				type: Boolean,
				default: false
			},
			tableData: {
				type: Array,
				default: () => []
			},
			tableColumns: {
				type: Array,
				default: () => []
			},
			deleteAllSelectedAction: {
				type: Function
			},
			selectAllAction: {
				type: Function
			},
			paginateLoader: {
				type: Boolean,
				default: false
			}
		},

		mounted() {
			setInterval(() => {
				if (this.$refs.tagTable)
					this.DOM.tagTable.width = this.$refs.tagTable.clientWidth || null
			}, 250)
		},

		data() {
			return {
				DOM: {
					tagTable: {
						width: null
					}
				}
			}
		},

		computed: {
			maxTagTable() {
				return this.DOM.tagTable.width <= 500
			},

			tagTableClass() {
				return {
					normal: this.maxTagTable
				}
			}
		},

		methods: {
			scrollHandler() {
				this.$emit('next')
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
